import { Component, inject } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { RouterService } from 'app/core/navigation';
import { TextIdModel } from 'app/shared/models/text-id.model';
import { TeacherService } from 'app/teacher/services/teacher.service';

@Component({
  selector: 'kh-generic-pick-class-modal',
  templateUrl: './generic-pick-class-modal.component.html',
  styleUrls: ['./generic-pick-class-modal.component.less'],
  standalone: false
})

export class GenericPickClassModalComponent {
  private readonly bsModalRef = inject(BsModalRef);
  private readonly teacherService = inject(TeacherService);
  private readonly router = inject(RouterService);

  public classes: TextIdModel[] = [];
  public selectedClassId = '';

  public selectClass(classId: string) {
    if (classId) {
      this.selectedClassId = classId;
      this.teacherService.activeClassId = classId;
      this.bsModalRef.hide();
    }
  }

  public getClassName = (c: TextIdModel) => c.text;

  public getClassId = (c: TextIdModel) => c.id;
}
